import React, {useState} from 'react';
import {withStyles} from "@material-ui/core/styles";
import {getEmbededTweetMarkup} from "../../../../../api/twitterApi";
import {DownloadIcon} from "../../../../../helpers/Icons";
import {Button, CircularProgress, Dialog, Fade, IconButton} from "@material-ui/core";
import {API_ROOT} from "../../../../../baseUrls";
// import {CloseFullscreen, OpenInFull} from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import {CloseFullscreen, OpenInFull} from "@mui/icons-material";

const styles = {
  previewThumbnail:{
    textAlign:'center',
    border: '1px solid rgba(0,0,0,0.27)',
    borderRadius: '0.25em',
    backgroundColor: 'rgba(0,0,0,0.050)',
    aspectRatio: 1,
    minHeight: '200px',
    minWidth: '200px',
    maxHeight: '350px',
    maxWidth: '350px',
    width: 'calc(min(100%,350px))',
    boxSizing: 'border-box'
  },
  thumbnail: {
    display: 'inline-flex',
    boxSizing:'border-box',
    width: '100%',
    height: '100%',
    verticalAlign: 'text-bottom',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
  preview:{
    flexGrow:1,
    flexBasis:'100%',
    textAlign:'center',
    position: 'relative'
  }, 
  expand:{
    position:'absolute',
    right: '0.5rem',
    bottom: '0.5rem',
    '& > button':{
      backgroundColor:"rgba(255,255,255,0.52)",
      color:"rgba(0,0,0,0.52)",
    },
    '& > button:hover':{
      backgroundColor:"rgba(0,0,0,0.87)",
      color:"rgba(255,255,255,0.87)",
    }
  },
  expandFullscreen:{
    position:'absolute',
    right: '0.5rem',
    bottom: '0.5rem',
    '& > button':{
      backgroundColor:"rgba(255,255,255,0.52)",
      color:"rgba(0,0,0,0.52)",
    },
    '& > button:hover':{
      backgroundColor:"rgba(0,0,0,0.87)",
      color:"rgba(255,255,255,0.87)",
    }
  },
  expandClose:{
    position:'absolute',
    right: '0.5rem',
    top: '0.5rem',
    '& > button':{
      backgroundColor:"rgba(255,255,255,0.52)",
      color:"rgba(0,0,0,0.52)",
    },
    '& > button:hover':{
      backgroundColor:"rgba(0,0,0,0.87)",
      color:"rgba(255,255,255,0.87)",
    }
  },
  closeLink:{
    whiteSpace:'nowrap',
    textDecoration:'underline',
    width: "fit-content",
    margin: "0 auto",
    cursor:'pointer',
    '&:hover':{
      opacity:0.65,
      backgroundColor:"rgba(255,255,255,0.85)",
    }
  },
  downloadLink:{
    whiteSpace:'nowrap',
    color:'rgba(0,0,0,0.87)',
    textDecoration: 'none',
    padding: '0 0 0 4px',
    borderRadius: 0,
    borderBottom:'1px solid rgba(0,0,0,0.87)',
    '&:hover':{
      opacity:0.65
    },
    '& > svg':{
      verticalAlign: 'bottom'
    }
  },
  conversionText:{
    padding:'0.85em',
    backgroundColor:'rgba(255,255,255,0.93)',
    border:'1px solid rgba(0,0,0,0.12)',
    margin: 'auto 1.5em 10%',
    fontWeight: 300,
    fontSize: '1.25em',
    position:"relative",
    minWidth: "14.5rem",
  },
  downloadLine:{
    marginTop:'0.75em',
  },
  loader:{
    margin: 'auto',
    animationDuration: '4000ms',
    '& > svg > circle':{
      animationDuration: '4000ms',
    }
  },
  fullScreen:{
    width:'100dvw',
    height: '100dvh',
    margin: 0,
    padding: 0,
  }
};

function UploadPreview(props) {
  const { id="itemPreview", item, ignoreConversion=false,
    thumbnailPath:userThumbnailPath, previewPath:userPreviewPath,
    handlePreviewClose, downloadFile, className,  mindfileUserLevel, classes } = props;

  const thumbnailPath = userThumbnailPath || `${API_ROOT}/mindfiles/${item.mindfile_id}/show/${item.item_data_id}/${item.url_show_hash}/thumbnail?ts=${item.url_ts}`;
  const previewPath = userPreviewPath || `${API_ROOT}/mindfiles/${item.mindfile_id}/show/${item.item_data_id}/${item.url_show_hash}/preview?ts=${item.url_ts}`;

  const classNames = !!className ? `${className} ${classes.preview}` : classes.preview;
  const classNamesThumbnail = !!className ? `${className} ${classes.previewThumbnail}` : classes.previewThumbnail;

  const [expand, setExpand] = useState(false);
  const [showUnavailable, setShowUnavailable] = useState(true);

  // const []

  const renderCloseLnk = () => {
    if(!handlePreviewClose){
      return null;
    }
    return <div id="itemPreviewClose" className={classes.closeLink} onClick={handlePreviewClose}>
      [Close Preview]
    </div>
  }
  const renderExpandLink = (fullscreen=false) => {
    return <div className={fullscreen ? classes.expandFullscreen : classes.expand}>
      <IconButton id="itemPreviewExpand" onClick={() => setExpand(!expand)}>
        {expand ? <CloseFullscreen /> : <OpenInFull />}
      </IconButton>
    </div>
  }
  const renderExpandCloseLink = () => {
    return <div className={classes.expandClose}>
      <IconButton id="itemPreviewExpandClose" onClick={() => setExpand(false)}>
        <CloseIcon />
      </IconButton>
    </div>
  }

  const renderImage = () => {
    return <div id={id} className={classNames}>
      <img src={previewPath} alt={item.name} style={{maxWidth: '100%', maxHeight: 'calc(max(100dvh - 320px, 320px))'}}/>
      {renderExpandLink()}
      {renderCloseLnk()}
      <Dialog onClose={() => setExpand(false)} fullScreen TransitionComponent={Fade} open={expand} keepMounted={false}  PaperProps={{style: {display:'flex', alignItems: "center", justifyContent: "center", backgroundColor:"#212121"}}}>
        {renderExpandCloseLink()}
        <img src={previewPath} alt={item.name} style={{maxWidth: '100%', maxHeight: '100%'}}/>
        {renderExpandLink(true)}
      </Dialog>
    </div>;
  }

  const renderVideo = () => {
    return (<div id={id} className={classNames}>
        <video id={`vidPreview`} style={{maxWidth: '100%', maxHeight: 'calc(max(100dvh - 320px, 320px))'}} controls>
          <source src={previewPath} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        {renderCloseLnk()}
      </div>);
  }

  const renderAudio = () => {
    return (
      <div id={id} className={classNames}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", maxWidth: '100%', minWidth:'175px' }} >
          <div style={{ position: "relative", flex:1, maxWidth:'100%', maxHeight:'300px', minHeight:'64px'}} >
            <img src={thumbnailPath} alt={item.name} style={{ flex:1, width:'100%', height:'100%', maxHeight:'300px' }} />
          </div>
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: '100%'}} >
            <audio controls style={{ flex:1 }}>
              <source src={previewPath} />
              Your browser does not support the audio element.
            </audio>
            <div style={{backgroundColor: '#474747', padding:'5px', height:'30px'}}>
              <IconButton size="small" id="itemPreviewExpand" onClick={() => setExpand(!expand)} style={{color: 'rgba(255,255,255,0.87'}}>
                {expand ? <CloseFullscreen /> : <OpenInFull  />}
              </IconButton>
            </div>
          </div>
        </div>
        {renderCloseLnk()}
          <Dialog onClose={() => setExpand(false)} fullScreen TransitionComponent={Fade} open={expand} keepMounted={false} PaperProps={{style: {display:'flex', justifyContent: "center", backgroundColor:"#212121"}}}>
            {renderExpandCloseLink()}
            <div style={{ margin: 'auto 0', maxHeight: "100%"}} >
              <div style={{ position: "relative", flex:1, width:'100%', maxHeight:'calc(100% - 40px)', display: 'flex'}} >
                <img src={thumbnailPath} alt={item.name} style={{ flex:1, width:'100%', maxHeight:'300px' }} />
              </div>
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: '100%'}} >
                <audio controls style={{ flex:1 }}>
                  <source src={previewPath} />
                  Your browser does not support the audio element.
                </audio>
                <div style={{backgroundColor: '#474747', padding:'5px', height:'30px'}}>
                  <IconButton size="small" id="itemPreviewExpand" onClick={() => setExpand(!expand)} style={{color: 'rgba(255,255,255,0.87'}}>
                    {expand ? <CloseFullscreen /> : <OpenInFull  />}
                  </IconButton>
                </div>
              </div>
            </div>
          </Dialog>
      </div>);
  };
  const renderDocument = () => {
    let previewEl;
    if (item.item_data.extension !== null && item.item_data.extension === "pdf") {
      previewEl = (
        <div style={{width: '100%', height: '100%', boxSizing:'border-box', border: '1px solid rgba(0,0,0,0.27)'}}>
          <iframe title='doc-preview' src={previewPath} style={{width:'100%', height: 'calc(100% - 4px)', boxSizing:'border-box', border: 'none'}} />
        </div>);
    } else if (item.item_data.extension !== null &&
      ["csv", "docx", "xslx", "doc", "odt", "odf", "ods", "xls", "xlsx", "pages", "numbers", "html", "html"].includes(item.item_data.extension)
    ) {
      previewEl = (
        <div style={{width: '100%', height: '100%', boxSizing:'border-box', border: '1px solid rgba(0,0,0,0.27)'}}>
          <iframe title='default-preview' src={previewPath} style={{width:'100%', height: 'calc(100% - 4px)', boxSizing:'border-box', border: 'none'}} sandbox="" />
        </div>);
    } else {
      previewEl = <img src={thumbnailPath} alt={item.name} style={{maxWidth:'100%', height: '100%'}} />;
    }
    return (
      <div id={id} className={classNames}>
        <div style={{width: '100%', height: '600px', maxHeight:'600px'}}>
          {previewEl}
        </div>
        {renderExpandLink()}
        {renderCloseLnk()}
        <Dialog onClose={() => setExpand(false)} fullScreen TransitionComponent={Fade} open={expand} keepMounted={false}>
          {renderExpandCloseLink()}
          {previewEl}
          {renderExpandLink(true)}
        </Dialog>
      </div>);
  };
  const renderPost = () => {
    if (item.item_data.source === "twitter") {
      getEmbededTweetMarkup(previewPath).then(markup => {
        const embedMarkup = markup || null;
        if (embedMarkup) {
          return <div id={id} className={classNames}>
              <div dangerouslySetInnerHTML={embedMarkup} />
              {renderExpandLink()}
              {renderCloseLnk()}
              <Dialog onClose={() => setExpand(false)} fullScreen TransitionComponent={Fade} open={expand} keepMounted={false} PaperProps={{style: {display:'flex', alignItems: "center", justifyContent: "center", backgroundColor:"#212121"}}}>
                {renderExpandCloseLink()}
                <div dangerouslySetInnerHTML={embedMarkup} />
                {renderExpandLink(true)}
              </Dialog>
            </div>;
        }
      });
    }
  };
  const renderDefault = () => {
    return <div id={id} className={classNamesThumbnail}>
      <div className={classes.thumbnail} style={{background: `url(${thumbnailPath}) 50% 50%/contain no-repeat`}}/>
    </div>;
  };

  const renderConversion = () => {
    return <div id={id} className={classNamesThumbnail}>
      {!showUnavailable ?
        <div className={classes.thumbnail} style={{background: `url(${thumbnailPath}) 50% 50%/contain no-repeat`, cursor: 'pointer'}}
             onClick={() => setShowUnavailable(true)}
        />
        : <div className={classes.thumbnail} style={{background: `url(${thumbnailPath}) 50% 50%/contain no-repeat`}}>
          { item.item_data.conversion !== false ?
            <div className={classes.conversionText}>
              <span id="itemPreviewUnavailable">Preview Unavailable</span>
              {!!downloadFile && mindfileUserLevel <= 1 ?
                <div className={classes.downloadLine}>
                  <Button
                    variant="text"
                    className={classes.downloadLink}
                    onClick={downloadFile}
                    startIcon={<DownloadIcon size="small"/>}
                  >
                    Download File
                  </Button> to view.
                </div>
                : null
              }
              <IconButton
                size="small"
                onClick={() => setShowUnavailable(false)}
                style={{position: "absolute", right: "0.25rem", top: "0.25rem", opacity: 0.65}}>
                <CloseIcon/>
              </IconButton>
            </div>
            : <CircularProgress
              style={{width: '75px', height: '75px', opacity: 0.85}}
              color="secondary"
              className={classes.loader}
              variant="indeterminate"
            />
          }
        </div>
      }
    </div>;
  };

  if(item.item_data.conversion !== true && !ignoreConversion){
    return renderConversion();
  }
  switch (item.item_data.type) {
    case "image": return renderImage();
    case "audio": return renderAudio();
    case "video": return renderVideo();
    case "document": return renderDocument();
    case "post": return renderPost();
    default: return renderDefault();
  }
}

export default withStyles(styles)(UploadPreview);
